import {
    //sellpoints
    ADD_SELLPOINT,
    ADD_SELLPOINT_SUCCESS,
    ALL_SELLPOINTS,
    ALL_SELLPOINTS_SUCCESS,

    //products
    ADD_PRODUCT,
    ADD_PRODUCT_SUCCESS,
    ALL_PRODUCTS,
    ALL_PRODUCTS_SUCCESS,
    PRODUCT_BY_ID,
    PRODUCT_BY_ID_SUCCESS,

    //cart
    VIEW_CART,
    ADD_TO_CART,
    REMOVE_FROM_CART,

    //messages
    ERROR_MSG
  } from './mutation-types'
  
  //

  //sellpoints
  export const sellpointMutations = {
    [ALL_SELLPOINTS] (state) {
      state.showLoader = true
      // this[]
    },
    [ALL_SELLPOINTS_SUCCESS] (state, payload) {
      state.showLoader = false
      state.sellpoints = payload
    },
    [ERROR_MSG] (state, payload) {}
    
  }

  //products
  export const productMutations = {
    [ALL_PRODUCTS] (state) {
      state.showLoader = true
      // this[]
    },
    [ALL_PRODUCTS_SUCCESS] (state, payload) {
      state.showLoader = false
      state.products = payload
    },
    [PRODUCT_BY_ID] (state) {
      state.showLoader = true
    },
    [PRODUCT_BY_ID_SUCCESS] (state, payload) {
      state.showLoader = false
      state.product = payload
    },
    [ERROR_MSG] (state, payload) {}
  }
  
  //cart
  export const cartMutations = {
    [VIEW_CART]: (state) => {
      return state.cart
    },
    [ADD_TO_CART]: (state, payload) => {
      state.cart.push(payload); 
      state.cart = state.cart;
    },
    // [REMOVE_FROM_CART]: (state, payload) => {
    //   const index = state.cart.findIndex(p => p._id === payload)
    //   state.cart.splice(index, 1)
    // }
    [REMOVE_FROM_CART]: (state, payload) => {
      const index = state.cart.findIndex(p => p._id === payload)
      state.cart.splice(index, 1)
    }
  }
  
  


// WEBPACK FOOTER //
// ./src/store/mutations.js